$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "user" && a === "organizer_login") {
    localStorage.removeItem("lastOrderTotal");
    localStorage.removeItem("lastOrderProducts");
  }
  let pinCodeInput = $("#pin-code-input");
  let pinCode = pinCodeInput.val();

  $(document).on("slid.bs.carousel", "#animate-container", function (event) {
    let activeIndex = $(event.relatedTarget).index(); // Get the index of the active slide

    // Reset all indicators
    $(".slide-indicator").each(function (index) {
      if (index === activeIndex) {
        $(this).css({
          width: "32px",
          height: "10px",
          backgroundColor: "#1178F8",
          borderRadius: "20px",
        });
      } else {
        $(this).css({
          width: "10px",
          height: "10px",
          backgroundColor: "#D9D9D9",
          borderRadius: "50%",
        });
      }
    });
  });

  $(document).on("click", ".pin-button, .pin-dot-mobile", function (e) {
    e.preventDefault();
    if (pinCode.length == 4) {
      return;
    }

    const value = $(this).data("value");
    pinCode += value;
    pinCodeInput.val(pinCode);

    $(".pin-dot").removeClass("filled");
    $(".pin-dot-mobile").removeClass("filled");
    if (pinCode && pinCode.length > 0) {
      for (let i = 0; i < pinCode.length; i++) {
        $(`.pin-dot:eq(${i})`).addClass("filled");
        $(`.pin-dot-mobile:eq(${i})`).addClass("filled");
      }
    }

    if (pinCode.length === 4) {
      $("#pin_login_form").submit();
    }
  });

  // Handle backspace
  $(document).on("click", "#backspace-btn", function () {
    if (pinCode.length < 1) {
      return;
    }
    pinCode = pinCodeInput.val().slice(0, -1);
    pinCodeInput.val(pinCode);
    $(".pin-dot").removeClass("filled");
    $(".pin-dot-mobile").removeClass("filled");
    if (pinCode && pinCode.length > 0) {
      for (let i = 0; i < pinCode.length; i++) {
        $(`.pin-dot:eq(${i})`).addClass("filled");
        $(`.pin-dot-mobile:eq(${i})`).addClass("filled");
      }
    }
  });

  // Handle clear
  $(document).on("click", ".clear-button", function () {
    if (pinCode.length < 1) {
      return;
    }
    pinCode = "";
    pinCodeInput.val("");
    $(".pin-dot").removeClass("filled");
    $(".pin-dot-mobile").removeClass("filled");
  });

  $(document).on("click", "#organizer-login", function () {
    $("#pin_login_form").submit();
  });

  $(document).on("click", ".close-alert", function () {
    $(".incorrect-pin-alert").removeClass("show").addClass("d-none");
  });

  $(document).on("submit", "#pin_login_form", function (e) {
    e.preventDefault();
    $(".pin-loader").removeClass("d-none");
    const redirect_url =
      !!location.search && location.search.indexOf("?redirect_url=") === 0
        ? location.search.replace("?redirect_url=", "")
        : "";

    const locations = Object.fromEntries(
      Object.entries(localStorage).filter(([key]) => key.endsWith('_mainLocationId'))
    );

      const formData = $(this).serializeArray();

      formData.push({ name: "is_android", value: !!window.ReactNativeWebView });

      if (deviceId) {
      formData.push({ name: "device_id", value: deviceId });
      }

      formData.push({ name: "locations", value: JSON.stringify(locations) });

      if (redirect_url !== "") {
      formData.push({ name: "redirect_url", value: decodeURIComponent(redirect_url) });
      }

      // Send AJAX request
      $.ajax({
      type: "POST",
      url: "/ajax/user/organizer_login",
      data: $.param(formData),
      })
      .done(function (data) {
        if (data.message !== undefined && data.message !== null) {
          pinCodeInput.val("");
          pinCode = "";
          $(".pin-loader").addClass("d-none");
          $(".pin-dot").removeClass("filled");
          $(".pin-dot-mobile").removeClass("filled");

          setTimeout(() => {
            $(".incorrect-pin-alert").removeClass("d-none").addClass("show");
          }, 10);
        } else if (
          data.success === true &&
          data.redirect_url !== undefined &&
          data.redirect_url != null
        ) {
          document.location.href = data.redirect_url;
        }
      })
      .fail(function (data) {
        $("#pin-code-input").val("");
        $(".pin-loader").addClass("d-none");
        if (
          data.responseJSON.error_message !== undefined &&
          data.responseJSON.error_message !== null
        ) {
          pinCodeInput.val("");
          pinCode = "";
          $(".pin-dot").removeClass("filled");
          $(".pin-dot-mobile").removeClass("filled");
          $(".incorrect-pin-alert").removeClass("d-none").addClass("show");
        }
      });

    return false;
  });
});
